import type { SxProps, Theme } from '@mui/material/styles';

export const rootSx: SxProps<Theme> = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 2,
  p: 3,
};

export const actionButtonSx: SxProps<Theme> = {
  px: 1,
  py: 0.75,
  borderRadius: '4px',
  color: 'primary.main',
  fontFamily: 'inherit',
  fontSize: 12,
  lineHeight: '16px',
  fontWeight: 'fontWeightBold',
  textTransform: 'uppercase',
  '&:hover, &.Mui-focusVisible': { backgroundColor: 'primary.light' },
};
